/* window.BotHistory: оболочка собрана компонентом, контракт PAGES тот же (init, mount, fill, after, stats, clear).
   Экран один: в серверном режиме движок шаблона получает источник historyServer вместо демо-таблицы. */
import { definePageModule } from '../../bridge/page-module';
import { isServerMode } from '../../platform/server-mode';
import { History } from './History';
import { createHistory } from './engine';
import { historyServer, type HistoryServer } from './history-server';

const SKIP = new Set(['markup', 'prepare', 'attach', 'init', 'unmount', 'S', 'fill', 'after', 'PREFIX', 'TESTS', 'mounted']);

export interface HistoryView {
  zero: boolean;
  body: string;
}

export interface HistoryApi {
  prepare: () => HistoryView;
  attach: () => void;
  init: (o: BotPageUi | { server: HistoryServer }) => void;
  unmount: () => void;
  fill: (...args: unknown[]) => void;
  after: () => void;
  S: object;
  PREFIX: string;
  TESTS: [string, [string, string][]][];
}

let api: HistoryApi;

/** Экран берёт api при отрисовке: installHistory уже вызван */
export function historyApi() {
  return api;
}

/** Методы и геттеры раздела, кроме тех, что забирает контракт страницы */
function liveExtras(b: object): Record<string, unknown> {
  const extra: Record<string, unknown> = {};
  for (const [k, d] of Object.entries(Object.getOwnPropertyDescriptors(b))) {
    if (SKIP.has(k)) continue;
    if (d.get) Object.defineProperty(extra, k, { enumerable: true, get: () => (b as Record<string, unknown>)[k] });
    else if (typeof d.value === 'function') {
      const fn = d.value as (...args: unknown[]) => unknown;
      extra[k] = (...args: unknown[]) => fn.apply(b, args);
    } else extra[k] = d.value;
  }
  return extra;
}

export function installHistory() {
  const server = isServerMode();
  const b = createHistory() as unknown as HistoryApi;
  if (server) b.init({ server: historyServer });
  api = b;
  definePageModule({
    global: 'BotHistory',
    PREFIX: b.PREFIX,
    TESTS: server ? [] : b.TESTS,
    S: b.S,
    Page: History,
    init(o) {
      b.init(o);
    },
    fill(...args: unknown[]) {
      if (!server) b.fill(...args);
    },
    after() {
      b.after();
    },
    beforeUnmount() {
      b.unmount();
    },
    extra: liveExtras(b),
  });
}
